import * as React from 'react';
import ReactMarkdown from 'markdown-to-jsx';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

const options = {
	overrides: {
		h1: {
			component: Typography,
			props: {
				gutterBottom: true,
				variant: 'h4',
			},
		},
		h2: {
			component: Typography,
			props: { gutterBottom: true, variant: 'subtitle1' },
		},
		h3: {
			component: Typography,
			props: { gutterBottom: true, variant: 'subtitle2' },
		},
		h4: {
			component: Typography,
			props: {
				gutterBottom: true,
				variant: 'caption',
				paragraph: true,
			},
		},
		subtitle1: {
			component: Typography,
			props: {
				gutterBottom: true,
				variant: 'caption',
				paragraph: true,
			},
		},
		subtitle2: {
			component: Typography,
			props: {
				gutterBottom: true,
				variant: 'caption',
				paragraph: true,
			},
		},
		p: {
			component: Typography,
			props: { paragraph: true },
		},
		a: { component: Link },
		ol: {
			component: (props: any) => (
				<Box component="ol" sx={{ mt: 2 }}>
					<Typography component="span" {...props} />
				</Box>
			),
		},
		li: {
			component: (props: any) => (
				<Box component="li" sx={{ mt: 2 }}>
					<Typography component="span" {...props} />
				</Box>
			),
		},
	},
};

export default function Markdown(props: any) {
	return <ReactMarkdown options={options} {...props} />;
}
